import { HugeiconsIcon } from "@hugeicons/react";
import { Delete02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { useReceiptDetail } from "hooks/useReceiptDetail";
import LoadingWithoutModal from "components/common/LoadingWithoutModal";
import { useTranslation } from "react-i18next";
import { ConfirmDialog, toast } from "@outpave/ds";

interface ConfirmReceiptDeleteModalProps {
  open: boolean;
  handleCloseModal: () => void;
  receiptId: string;
  refetchReceipts?: () => void;
  onClose?: () => void;
}

const ConfirmReceiptDeleteModal: React.FC<ConfirmReceiptDeleteModalProps> = ({
  open,
  handleCloseModal,
  receiptId,
  refetchReceipts,
  onClose,
}) => {
  const { deleteReceiptDetail, deletingReceiptDetail } = useReceiptDetail(
    receiptId,
    { skipQuery: true },
  );

  const { t } = useTranslation();

  const handleDeleteReceipt = async () => {
    try {
      await deleteReceiptDetail({ variables: { id: receiptId } });
      toast.success(t("Receipt deleted successfully"));
      refetchReceipts?.();
      handleCloseModal();
      onClose?.();
    } catch (error) {
      console.error("Error deleting receipt:", error);
      toast.error(t("Error deleting receipt"));
    }
  };

  return (
    <>
      <ConfirmDialog
        open={open}
        tone="danger"
        title={t("Delete Receipt")}
        message={t("Are you sure you want to delete this receipt?")}
        confirmLabel={t("Yes")}
        cancelLabel={t("No")}
        busy={deletingReceiptDetail}
        onConfirm={handleDeleteReceipt}
        onCancel={() => {
          if (deletingReceiptDetail) return;
          handleCloseModal();
        }}
        // The chip carries the danger colour; the glyph only says which
        // destruction this is.
        icon={
          <HugeiconsIcon icon={Delete02Icon} size={24} color="currentColor" />
        }
      />
      <LoadingWithoutModal open={deletingReceiptDetail} />
    </>
  );
};

export default ConfirmReceiptDeleteModal;
